import { Button, Card, Spin, Table, Tag, message } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Link } from "react-router-dom";
import { useSellerTransectionQueue, useTransectionProcess } from '../../../hooks/seller_hooks/seller.req';
import { Status } from './components/Status';

import { wait } from '../../../helper/wait';

const SellerTransectionReport = () => {
    
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);

    const { data, isLoading } = useSellerTransectionQueue({ page, limit  });
    const { mutate, isLoading:processing, data:processData } = useTransectionProcess();

    const [curr_process, setCurr_process] = useState('');


    const queryClient = useQueryClient();

    function getFreshData(){
        queryClient.invalidateQueries(['seller_transection_queue', page, limit]);
    }

    async function invalidate(timeout){
        await wait(timeout);
        getFreshData();
    }

    const columns = [
        {
            title: 'Date',
            dataIndex: '_date',
            key: '_date',
            render: (text) => {
                return moment(text).format('DD-MM-YYYY');
            }
        },
        {
            title: 'Order ID',
            dataIndex: 'order_id',
            render: order_id => <Link to={`/order_detail/${order_id}`}> <Tag>{order_id}</Tag> </Link>
        },
        {
            title: 'Seller ID',
            dataIndex: 'seller_id',
            key: 'seller_id',
            render: (seller_id, row) => <Link to={`/seller_detail/${row?.seller_id}`}> <Tag>{row?.shop_name}</Tag> </Link>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status, row) => {
                if(status === 'queued'){
                    return <Status status={status} color='blue' />
                }
                if(status === 'completed'){
                    return <Status status={status} color='green' />
                }
                if(status === '	cancelled'){
                    return <Status status={status} color='red' />
                }
               return <Status status={status} color='red' />
            }
        },
        {
            title: '*',
            dataIndex: 'id',
            key: 'id',
            render:(id, row) => {
                if(row.status !== 'queued'){
                    return <></>
                }

                if(curr_process == row?.order_id && processing){
                    return <Spin size='small' />
                }
                
                return <Button 
                size='small'
                onClick={e => {
                    setCurr_process(row?.order_id);

                    mutate({order_id: row.order_id}, {
                        onSuccess:(_) => {
                            message.success('Transection Process started');
                            invalidate(0);
                            invalidate(1000);
                            invalidate(2000);
                            invalidate(3000);
                        }
                    })
                }}>process</Button>
            }
        },
        
    ];


  return (
    <div>
        <Card 
            title="Seller Transection Process Report"
            extra={[
                <Link 
                    to={'/reports'} key={'toda-processed'}  >
                    <Button 
                        color='#333'
                    >Back</Button>
                </Link>
            ]}
        >
            <Table 
                loading={isLoading}
                size='small' 
                dataSource={data?.data || []} 
                columns={columns} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize: limit,
                    defaultCurrent: page,
                    total: data?.totalCount || 0,
                    onChange: (page) => {
                        setPage(page);
                    },
                    onShowSizeChange: (current, size) => {
                        setLimit(size);
                    },
                }}
            />
        </Card>
    </div>
  )
}

export default SellerTransectionReport;
